import React from "react";
import { Tooltip } from "antd";
import Icons from "components/icons";
import { Localize } from "components/service";
import {
    getStaffAttendanceWarningTranslationKey,
    getStaffAttendanceStatusIconKey,
} from "../helpers/staff-attendance-session-helper";


const statusLabels = {
    in_progress: "STAFF_MANAGEMENT.AttendanceStatus_InProgress",
    failed_checkout: "STAFF_MANAGEMENT.AttendanceStatus_FailedCheckout",
    missed_checkout: "STAFF_MANAGEMENT.AttendanceStatus_MissedCheckout",
};

const statusIcons = {
    in_progress: Icons.StaffInProcess,
    clock: Icons.StaffClock,
    failed_checkout: Icons.StaffAttention,
    missed_checkout: Icons.StaffClock,
};

const StaffAttendanceStatusField = ({ status, warningCodes }) => {
    const label = statusLabels[ status ];
    const StatusIcon = statusIcons[ getStaffAttendanceStatusIconKey(status, warningCodes) ];
    const warningTranslationKey = getStaffAttendanceWarningTranslationKey(warningCodes);

    if (!label)
    {
        return <>&mdash;</>;
    }

    return (
        <span className={ `staff-attendance-status staff-attendance-status--${ status.replace(/_/g, "-") }` }>
            { StatusIcon && <StatusIcon aria-hidden="true" /> }
            <Localize>{ label }</Localize>
            { warningTranslationKey &&
                <Tooltip
                    overlayClassName="staff-attendance-warning-tooltip"
                    placement="bottomLeft"
                    trigger={ [ "hover", "focus", "click" ] }
                    title={ <Localize>{ warningTranslationKey }</Localize> }>
                    <button
                        type="button"
                        className="d-flex align-items-center justify-content-center staff-attendance-warning-icon"
                        onClick={ (event) => event.stopPropagation() }>
                        <Icons.StaffInfo aria-hidden="true" />
                        <span className="visually-hidden">
                            <Localize>{ warningTranslationKey }</Localize>
                        </span>
                    </button>
                </Tooltip>
            }
        </span>
    );
};

export default StaffAttendanceStatusField;
